import React from 'react'

class Access extends React.Component {
  render() {
    return (
      <div className="content-container" id="access">
        <div className="content-title">アクセス</div>
        <div className="access-address">
          <span>
            中町内科医院
            <br />
          </span>
          <span>
            〒180-0006 東京都武蔵野市中町２丁目３１−１２
            <br />
          </span>
          <span>最寄り駅 ＪＲ三鷹駅より約徒歩８分</span>
        </div>
        <div className="map-container">
          <iframe
            title="map-access"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3239.871146263824!2d139.5675320919579!3d35.70478835674744!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6018efb2e09a844b%3A0x1b1bd09a37e28dd7!2z5Lit55S65YaF56eR5Yy76Zmi!5e0!3m2!1sja!2sjp!4v1645235806261!5m2!1sja!2sjp"
            width="80%"
            height="450"
            allowFullScreen=""
            loading="lazy" //styleはReactでは使えない
          ></iframe>
        </div>
      </div>
    )
  }
}

export default Access
